export const odluka_o_isplati_dara_djetetu_do_15_godina_starosti = {
    templateId: 37,
    category: 4,
    templateTitle: 'Odluka o darivanju djece radnika do 15 godina starosti',
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) dijete radnika do 15. godina starosti darivati u novcu ili u naravi, pri čemu je navedeni dar neoporeziv do vrijednosti 1.000,00 kn godišnje.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubraja se i isplata dara djetetu do 15 godina starosti (uključivo i djeteta koje je do dana 31. prosinca tekuće godine navršilo 15 godina starosti).</p>
    <p>Dakle, ako poslodavac isplaćuje dar djetetu, radnik ima pravo na dar za svako dijete koje je bilo kada tijekom tekuće godine, a zaključno sa 31.12. tekuće godine navršilo 15 godina.</p>
    <p>Navedeni dar djetetu do 15 godina starosti neoporeziv je do najviše 1.000,00 kn godišnje.</p>
    <p>Darivanje može biti u naravi ili u novcu.</p>
    <p>Ako poslodavac isplaćuje dar u novcu, isplata može biti u gotovini iz blagajne ili na tekući račun, dok sama isplata može biti obavljena uz isplatu redovne plaće ili zasebno.</p>

    <p>Dar djetetu do 15. godine starosti smatra se materijalnim pravom radnika, a koje nije izravno propisano Zakonom o radu, nego se po potrebi uređuje kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Međutim, ukoliko navedeno pravo nije propisano pravilnikom o radu ili kolektivnim ugovorom odnosno ako nije određeno ugovorom o radu, onda poslodavac samostalno odlučuje hoće li to pravo omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Također, dar djetetu je za poslodavca porezno priznati trošak s aspekta utvrđivanja osnovice poreza na dobit.</p>
    <p>Osim toga, prema odredbama Ovršnog zakona, dar za djecu do 15. godine života do propisanog neoporezivog iznosa primitka po osnovi nesamostalnog rada izuzet je od ovrhe te se u slučaju blokade računa radnika uplaćuje se na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).</p>
    <p>Međutim, ovaj primitak je izuzet od ovrhe samo do propisanih iznosa do kojih se smatraju neoporezivim primicima po osnovi od nesamostalnog rada, što znači da se u dijelu u kojem se smatraju oporezivim primicima po osnovi od nesamostalnog rada ne mogu isplatiti na zaštićeni, već na redovni račun.</p>

    <p>U slučaju da su oba roditelja zaposlena kod istog poslodavca, sukladno mišljenju Porezne uprave, moguće je isplatiti dar za oba roditelja.</p>
    <p>Isto tako, u slučaju da radnik ima više djece, iznos od 1.000,00 kn moguće je isplatiti (neoporezivo) po djetetu, odnosno, svako dijete moguće je darivati navedenim iznosom.</p>
    <p>Valja imati na umu da ukoliko je navedeno pravo različito uređeno (npr. kolektivni ugovor propisuje to pravo drugačije nego pravilnik o radu), primjenjuje se najpovoljnije pravo za radnika, te se navedeno pravo ne bi smjelo prekršiti npr. odlukom poslodavca ili pravilnikom o radu.</p>
    <p>U tom smislu, poslodavac može, u slučaju da navedeno pravo nije uređeno kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu, posebnom odlukom odrediti to pravo u manjem opsegu (npr. odrediti da se dar djetetu isplaćuje djeci do 12 godina starosti ili samo djeci radnika koji su zdravstveno osigurani preko radnika).</p>
    <p>Poslodavac može dar djetetu isplatiti radniku u gotovini iz blagajne ili na tekući račun, a isplata može biti obavljena uz isplatu redovne plaće ili posebno.</p>
    <p><strong>SVRHA DOKUMENTA</strong></p>
    <p>Isplata dara djeci, najčešće kroz darivanje u naravi, prigodom božićnih i uskršnjih blagdana.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],


    headline: ' donosi sljedeću',
    title: 'ODLUKA O DARIVANJU DJECE RADNIKA ',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Ovom Odlukom se pobliže definira darivanje djece radnika.',
                        'Ovom Odlukom se pobliže definira darivanje djece radnika koji su zdravstveno osigurani preko radnika.',
                        'Ovom Odlukom se pobliže definira darivanje djece radnika koje radnici imaju prijavljene u poreznoj kartici.'
                 ],
                 placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Pravo na dar imaju djeca do navršene 15-te godine života u tekućoj godini.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Pravo na dar imaju djeca do navršene'},
                                {type: 'input', value: '', required: true, help: 'Poslodavac može odlučiti da pravo na dar imaju samo mlađa djeca radnika, osim ako je već pravilnikom o radu ili kolektivnim ugovorom propisana starost djece koja imaju pravo na dar. Preduvjet neoporezivosti je i u tom slučaju da su djeca do 15. godina starosti.'},
                                {type: 'text', content: '-te godine života u tekućoj godini.'}]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Poslodavac će darivanje iz ove Odluke izvršiti darom u naravi ukupne vrijednosti do'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Poslodavac će dar iz ove Odluke isplatiti radniku u vrijednosti od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'},
                                {
                                    type: 'text',
                                    content: 'Poslodavac isplaćuje dar na redovan račun radnika, no u slučaju da radnik ima otvoren zaštićeni račun, sredstva se doznačuju na zaštićeni račun.'
                                }]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Poslodavac će dar iz ove Odluke isplatiti radniku u vrijednosti od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'},
                                {type: 'text', content: 'Poslodavac će dar radniku isplatiti u gotovini.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Poslodavac će dar iz ove Odluke isplatiti radniku u vrijednosti od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'},
                                {
                                    type: 'text',
                                    content: 'Poslodavac samostalno odlučuje u svakom pojedinom slučaju na koji način će se isplatiti dar iz ove Odluke,'
                                },
                                {
                                    type: 'text',
                                    content: 'u gotovini ili na redovan račun Radnika (no u slučaju da radnik ima otvoren zaštićeni račun, sredstva se'
                                },
                                {type: 'text', content: 'doznačuju na zaštićeni račun).'}]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ukoliko postoji zakonska mogućnost korištenja neoporezive isplate, pri isplati dara djeci koristiti će se ta porezna mogućnost.',
                    value: '',
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
            value: '',
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Kadrovska služba \r\n2) Obračun plaća \r\n\r\nObavijest o odluci: Oglasna ploča',
                    help: 'Po želji, slobodno izmijenite/obrišite predložene unose odnosno dopišite istima željene podatke.'
                }
            ]
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/37_odluka_o_isplati_dara_djetetu_do_15_godina_starosti.ts